import { isTest } from 'pkg/config/app';

import { isDev } from 'pkg/flags';

const warned = new Set<string>();

// Logs a one-time warning per component/prop pair in development builds.
// Silent in tests and production, and never throws before app config is set.
export function deprecationWarning(
	component: string,
	prop: string,
	hint: string
): void {
	const key = `${component}.${prop}`;

	if (warned.has(key)) {
		return;
	}

	try {
		if (isTest() || !isDev()) {
			return;
		}
	} catch {
		return;
	}

	warned.add(key);

	console.warn(`[deprecated] <${component} ${prop}>: ${hint}`);
}
